import { LitElement, html, css } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';

class BnButton extends LitElement {
  static get properties() {
    return {
      variant: { type: String },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .button {
        width: var(--bn-button-width, unset);
      }
    `];
  }

  render() {
    return html`
      <button class="button button--${this.variant || 'contained'}">
        <slot></slot>
      </button>
    `;
  }
}

customElements.define('bn-button', BnButton);
